import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, firstValueFrom, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Environment } from '../../../environments/environment.model';

@Injectable()
export class AppConfigService {
  private http = inject(HttpClient);

  loadConfig(): Promise<void> {
    return firstValueFrom(
      this.http.get<Environment>('/assets/config/app.config.json').pipe(
        catchError((error) => {
          // Handle network errors, CORS issues, or missing file
          if (error.status === 0) {
            console.warn('Network or CORS issue while loading app config. Using default environment.', error);
          } else {
            console.warn('Failed to load app config. Using default environment.', error);
          }
          return of(environment); // fallback to default
        }),
      ),
    ).then((data) => {
      const config: Environment = data ?? environment;
      Object.assign(environment, config);
    });
  }
}
